export default __webpack_public_path__ + "static/media/done.9a4c3ac2.png";